// import React from "react";
// import Nav from "../HomePage/Nav";
// import help from "../../assets/Images/vatsal-bhatt-KwhxKAjhIjQ-unsplash1.png";
// import "react-toastify/dist/ReactToastify.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebook,
//   faInstagram,
//   faYoutube,
// } from "@fortawesome/free-brands-svg-icons";
// import p1 from "../../assets/Images/P1.png";
// import p2 from "../../assets/Images/P2.png";
// import lad from "../../assets/Images/11.png";
// import snow from "../../assets/Images/12.png";

// const ContactUs = () => {
//   return (
// <>
//   {/* ✅ Background + Overlay Wrapper */}
//   <div
//     style={{
//       backgroundImage: `url(${help})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       minHeight: "100vh",
//       width: "100%",
//       position: "relative",
//     }}
//   >
//     {/* ✅ Black overlay */}
//     <div
//       style={{
//         backgroundColor: "rgba(0, 0, 0, 0.6)",
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         zIndex: 1,
//       }}
//     />

//     {/* ✅ Page Content */}
//     <div style={{ position: "relative", zIndex: 2 }}>
//       <Nav />

//       {/* Contact Info Section */}
//       <div className="container text-white d-flex align-items-end justify-content-between" style={{height:"368px"}}>
//         <div className="row text-center w-100">
//           <div className="col-md-4 p-5">
//             <h4
//               style={{
//                 fontFamily: "Montserrat",
//                 fontWeight: 600,
//                 fontSize: "52px",
//                 lineHeight: "100%",
//                 letterSpacing: "0%",
//                 verticalAlign: "middle",
//               }}
//             >
//               <b>Contact Us</b>
//             </h4>
//             <p>Get in touch with us for any enquiries and questions</p>
//           </div>

//           <div className="col-md-4 mt-5">
//             <h5><b>Mobile</b></h5>
//             <a href="tel:+917006363828" className="text-white d-block text-decoration-none">+91 7006363828</a>
//             <a href="tel:+919149516495" className="text-white d-block mt-2 text-decoration-none">+91 9149516495</a>
//             <h5 className="mt-4"><b>Address</b></h5>
//             <p className="mb-0">Chhutay Rantak, Sankar Road</p>
//             <p>Opp. Hotel Antelope, Leh-Ladakh, 194101</p>
//           </div>

//           <div className="col-md-4 mt-5 d-md-flex flex-md-column justify-content-lg-around">
//           <div className="mail-box">
//             <h5><b>Mail</b></h5>
//             <a href="mailto:travellerschoice27@gmail.com" className="text-white text-decoration-none mb-3 d-block">travellerschoice27@gmail.com</a>
//             </div>
//             <div className="social-box"> 
//             <h5 className="mt-4"><b>Social Media</b></h5>
//             <div className="d-flex justify-content-center gap-2">
//               <a href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle" style={{ width: "40px" }}>
//                 <FontAwesomeIcon icon={faFacebook} className="text-primary" />
//               </a>
//               <a href="https://www.instagram.com/travellers_choice_ladakh/" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle" style={{ width: "40px" }}>
//                 <FontAwesomeIcon icon={faInstagram} className="text-primary" />
//               </a>
//               <a href="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle" style={{ width: "40px" }}>
//                 <FontAwesomeIcon icon={faYoutube} className="text-primary" />
//               </a>
//             </div>
//              </div>
//           </div>
//         </div>
//       </div>

//       {/* ✅ Image Grid
//       <div className="w-100 py-4">
//         <div className="container">
//           <div className="row g-3">
//             <div className="col-12 col-md-6">
//               <div className="d-flex gap-3 mb-3">
//                 <img src={p1} alt="p1" className="img-fluid rounded" style={{ width: "66%", height: "200px", objectFit: "cover" }} />
//                 <img src={p2} alt="p2" className="img-fluid rounded" style={{ width: "34%", height: "200px", objectFit: "cover" }} />
//               </div>
//               <img src={p1} alt="p3" className="img-fluid rounded w-100" style={{ height: "200px", objectFit: "cover" }} />
//             </div>

//             <div className="col-12 col-md-6">
//               <div className="d-flex gap-3 mb-3">
//                 <img src={lad} alt="lad" className="img-fluid rounded w-50" style={{ height: "200px", objectFit: "cover" }} />
//                 <img src={snow} alt="snow" className="img-fluid rounded w-50" style={{ height: "200px", objectFit: "cover" }} />
//               </div>
//               <img src={p2} alt="p4" className="img-fluid rounded w-100" style={{ height: "200px", objectFit: "cover" }} />
//             </div>
//           </div>
//         </div>
//       </div> */}
//       <div className="w-100 py-4">
//   <div className="container">
//     <div className="row g-3">
//       {/* Row 1 */}
//       <div className="col-12 d-flex flex-wrap gap-3 justify-content-between">
//         <img
//           src={p1}
//           alt="p1"
//           className="rounded"
//           style={{ width: "32%", height: "200px",   objectFit: "cover" }}
//         />
//         <img
//           src={p2}
//           alt="p2"
//           className="rounded"
//           style={{ width: "64%", height: "200px", objectFit: "cover" }}
//         />
//       </div>

//       {/* Row 2 */}
//       <div className="col-12 d-flex flex-wrap gap-3 justify-content-between">
//         <img
//           src={lad}
//           alt="lad"
//           className="rounded"
//           style={{ width: "32%", height: "200px", objectFit: "cover" }}
//         />
//         <img
//           src={snow}
//           alt="snow"
//           className="rounded"
//           style={{ width: "32%", height: "200px", objectFit: "cover" }}
//         />
//         <img
//           src={p2}
//           alt="p4"
//           className="rounded"
//           style={{ width: "32%", height: "200px", objectFit: "cover" }}
//         />
//       </div>
//     </div>
//   </div>
// </div>

//     </div>
//   </div>
// </>

//   );
// };

// export default React.memo(ContactUs);


// import React from "react";
// import Nav from "../HomePage/Nav";
// import help from "../../assets/Images/vatsal-bhatt-KwhxKAjhIjQ-unsplash1.png";
// import "react-toastify/dist/ReactToastify.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebook,
//   faInstagram,
//   faYoutube,
// } from "@fortawesome/free-brands-svg-icons";
// import p1 from "../../assets/Images/P1.png";
// import p2 from "../../assets/Images/P2.png";
// import lad from "../../assets/Images/11.png";
// import snow from "../../assets/Images/12.png";

// const ContactUs = () => {
//   return (
// <>
//   {/* ✅ Background + Overlay Wrapper */}
//   <div
//     style={{
//       backgroundImage: `url(${help})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       minHeight: "100vh",
//       width: "100%",
//       position: "relative",
//     }}
//   >
//     {/* ✅ Black overlay */}
//     <div
//       style={{
//         backgroundColor: "rgba(0, 0, 0, 0.6)",
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         zIndex: 1,
//       }}
//     />

//     {/* ✅ Page Content */}
//     <div style={{ position: "relative", zIndex: 2 }}>
//       <Nav />

//       {/* Contact Info Section */}
//       <div className="container text-white d-flex align-items-end justify-content-between" style={{height: "368px", minHeight: "300px"}}>
//         <div className="row text-center w-100 g-3">
//           <div className="col-12 col-md-4 p-3 p-md-5">
//             <h4
//               className="h2 h1-md"
//               style={{
//                 fontFamily: "Montserrat",
//                 fontWeight: 600,
//                 fontSize: "clamp(32px, 8vw, 52px)",
//                 lineHeight: "100%",
//                 letterSpacing: "0%",
//                 verticalAlign: "middle",
//               }}
//             >
//               <b>Contact Us</b>
//             </h4>
//             <p className="mb-0">Get in touch with us for any enquiries and questions</p>
//           </div>

//           <div className="col-12 col-md-4 mt-3 mt-md-5">
//             <h5><b>Mobile</b></h5>
//             <a href="tel:+917006363828" className="text-white d-block text-decoration-none">+91 7006363828</a>
//             <a href="tel:+919149516495" className="text-white d-block mt-2 text-decoration-none">+91 9149516495</a>
//             <h5 className="mt-4"><b>Address</b></h5>
//             <p className="mb-0">Chhutay Rantak, Sankar Road</p>
//             <p>Opp. Hotel Antelope, Leh-Ladakh, 194101</p>
//           </div>

//           <div className="col-12 col-md-4 mt-3 mt-md-5 d-md-flex flex-md-column justify-content-lg-around">
//           <div className="mail-box mb-3 mb-md-0">
//             <h5><b>Mail</b></h5>
//             <a href="mailto:travellerschoice27@gmail.com" className="text-white text-decoration-none mb-3 d-block">travellerschoice27@gmail.com</a>
//             </div>
//             <div className="social-box"> 
//             <h5 className="mt-4 mt-md-4"><b>Social Media</b></h5>
//             <div className="d-flex justify-content-center gap-2">
//               <a href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
//                 <FontAwesomeIcon icon={faFacebook} className="text-primary" />
//               </a>
//               <a href="https://www.instagram.com/travellers_choice_ladakh/" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
//                 <FontAwesomeIcon icon={faInstagram} className="text-primary" />
//               </a>
//               <a href="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
//                 <FontAwesomeIcon icon={faYoutube} className="text-primary" />
//               </a>
//             </div>
//              </div>
//           </div>
//         </div>
//       </div>

//       {/* ✅ Responsive Image Grid */}
//       <div className="w-100 py-4">
//         <div className="container">
//           <div className="row g-3">
//             {/* Desktop and Tablet Layout */}
//             <div className="d-none d-md-block">
//               {/* Row 1 */}
//               <div className="col-12 d-flex flex-wrap gap-3 justify-content-between mb-3">
//                 <img
//                   src={p1}
//                   alt="p1"
//                   className="rounded"
//                   style={{ width: "32%", height: "200px", objectFit: "cover" }}
//                 />
//                 <img
//                   src={p2}
//                   alt="p2"
//                   className="rounded"
//                   style={{ width: "64%", height: "200px", objectFit: "cover" }}
//                 />
//               </div>

//               {/* Row 2 */}
//               <div className="col-12 d-flex flex-wrap gap-3 justify-content-between">
//                 <img
//                   src={lad}
//                   alt="lad"
//                   className="rounded"
//                   style={{ width: "32%", height: "200px", objectFit: "cover" }}
//                 />
//                 <img
//                   src={snow}
//                   alt="snow"
//                   className="rounded"
//                   style={{ width: "32%", height: "200px", objectFit: "cover" }}
//                 />
//                 <img
//                   src={p2}
//                   alt="p4"
//                   className="rounded"
//                   style={{ width: "32%", height: "200px", objectFit: "cover" }}
//                 />
//               </div>
//             </div>

//             {/* Mobile Layout - Stacked Images */}
//             <div className="d-md-none">
//               <div className="row g-3">
//                 <div className="col-12">
//                   <img
//                     src={p1}
//                     alt="p1"
//                     className="img-fluid rounded w-100"
//                     style={{ height: "200px", objectFit: "cover" }}
//                   />
//                 </div>
//                 <div className="col-12">
//                   <img
//                     src={p2}
//                     alt="p2"
//                     className="img-fluid rounded w-100"
//                     style={{ height: "200px", objectFit: "cover" }}
//                   />
//                 </div>
//                 <div className="col-12">
//                   <img
//                     src={lad}
//                     alt="lad"
//                     className="img-fluid rounded w-100"
//                     style={{ height: "200px", objectFit: "cover" }}
//                   />
//                 </div>
//                 <div className="col-12">
//                   <img
//                     src={snow}
//                     alt="snow"
//                     className="img-fluid rounded w-100"
//                     style={{ height: "200px", objectFit: "cover" }}
//                   />
//                 </div>
//                 <div className="col-12">
//                   <img
//                     src={p2}
//                     alt="p4"
//                     className="img-fluid rounded w-100"
//                     style={{ height: "200px", objectFit: "cover" }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//     </div>
//   </div>
// </>

//   );
// };

// export default React.memo(ContactUs);

import React from "react";
import Nav from "../HomePage/Nav";
import help from "../../assets/Images/vatsal-bhatt-KwhxKAjhIjQ-unsplash1.png";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import p1 from "../../assets/Images/P1.png";
import p2 from "../../assets/Images/P2.png";
import lad from "../../assets/Images/11.png";
import snow from "../../assets/Images/12.png";

const ContactUs = () => {
  return (
<>
  <style>
    {`
      /* Mobile devices (up to 768px) */
      @media (max-width: 767.98px) {
        .contact-info-section {
          height: auto !important;
          min-height: auto !important;
          padding-top: 2rem !important;
          padding-bottom: 2rem !important;
        }
        
        .contact-info-section .d-flex {
          align-items: flex-start !important;
        }
      }
      
      /* Desktop and larger screens */
      @media (min-width: 768px) {
        .contact-info-section {
          height: 368px;
          min-height: 300px;
        }
      }
    `}
  </style>

  {/* ✅ Background + Overlay Wrapper */}
  <div
    style={{
      backgroundImage: `url(${help})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      width: "100%",
      position: "relative",
    }}
  >
    {/* ✅ Black overlay */}
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
      }}
    />

    {/* ✅ Page Content */}
    <div style={{ position: "relative", zIndex: 2 }}>
      <Nav />

      {/* Contact Info Section */}
      <div className="container text-white d-flex align-items-end justify-content-between contact-info-section">
        <div className="row text-center w-100 g-3">
          <div className="col-12 col-md-4 p-3 p-md-5">
            <h4
              className="h2 h1-md"
              style={{
                fontFamily: "Montserrat",
                fontWeight: 600,
                fontSize: "clamp(32px, 8vw, 52px)",
                lineHeight: "100%",
                letterSpacing: "0%",
                verticalAlign: "middle",
              }}
            >
              <b>Contact Us</b>
            </h4>
            <p className="mb-0">Get in touch with us for any enquiries and questions</p>
          </div>

          <div className="col-12 col-md-4 mt-3 mt-md-5">
            <h5><b>Mobile</b></h5>
            <a href="tel:+917006363828" className="text-white d-block text-decoration-none">+91 7006363828</a>
            <a href="tel:+919149516495" className="text-white d-block mt-2 text-decoration-none">+91 9149516495</a>
            <h5 className="mt-4"><b>Address</b></h5>
            <p className="mb-0">Chhutay Rantak, Sankar Road</p>
            <p>Opp. Hotel Antelope, Leh-Ladakh, 194101</p>
          </div>

          <div className="col-12 col-md-4 mt-3 mt-md-5 d-md-flex flex-md-column justify-content-lg-around">
          <div className="mail-box mb-3 mb-md-0">
            <h5><b>Mail</b></h5>
            <a href="mailto:travellerschoice27@gmail.com" className="text-white text-decoration-none mb-3 d-block">travellerschoice27@gmail.com</a>
            </div>
            <div className="social-box"> 
            <h5 className="mt-4 mt-md-4"><b>Social Media</b></h5>
            <div className="d-flex justify-content-center gap-2">
              <a href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faFacebook} className="text-primary" />
              </a>
              <a href="https://www.instagram.com/travellers_choice_ladakh/" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faInstagram} className="text-primary" />
              </a>
              <a href="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faYoutube} className="text-primary" />
              </a>
            </div>
             </div>
          </div>
        </div>
      </div>

      {/* ✅ Responsive Image Grid */}
      <div className="w-100 py-4">
        <div className="container">
          <div className="row g-3">
            {/* Desktop and Tablet Layout */}
            <div className="d-none d-md-block">
              {/* Row 1 */}
              <div className="col-12 d-flex flex-wrap gap-3 justify-content-between mb-3">
                <img
                  src={p1}
                  alt="p1"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={p2}
                  alt="p2"
                  className="rounded"
                  style={{ width: "64%", height: "200px", objectFit: "cover" }}
                />
              </div>

              {/* Row 2 */}
              <div className="col-12 d-flex flex-wrap gap-3 justify-content-between">
                <img
                  src={lad}
                  alt="lad"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={snow}
                  alt="snow"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={p2}
                  alt="p4"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
              </div>
            </div>

            {/* Mobile Layout - Stacked Images */}
            <div className="d-md-none">
              <div className="row g-3">
                <div className="col-12">
                  <img
                    src={p1}
                    alt="p1"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={p2}
                    alt="p2"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={lad}
                    alt="lad"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={snow}
                    alt="snow"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={p2}
                    alt="p4"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</>

  );
};

export default React.memo(ContactUs);





// import React from "react";
// import Nav from "../HomePage/Nav";
// import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
// import p1 from "../../assets/Images/P1.png";
// import p2 from "../../assets/Images/P2.png";
// import lad from "../../assets/Images/11.png";
// import snow from "../../assets/Images/12.png";
//  import help from "../../assets/Images/vatsal-bhatt-KwhxKAjhIjQ-unsplash1.png";
// const ContactUs = () => {
//   // Using placeholder images from Unsplash for the gallery3
//   return (
//     <div
//       className="min-h-screen w-full relative bg-cover bg-center bg-no-repeat"
//       style={{
//         backgroundImage: `url(${help})`,
//       }}
//     >
//       {/* Black overlay */}
//       <div className="absolute inset-0 bg-black bg-opacity-60" />

//       {/* Page Content */}
//       <div className="relative z-10">
//         <Nav />

//         {/* Main Content Container */}
//         <div className="container mx-auto px-4 py-8">
//           {/* Contact Section */}
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 text-white mb-12">
//             {/* Contact Us Title */}
//             <div className="lg:col-span-4">
//               <h1 className="text-5xl lg:text-6xl font-bold mb-4 leading-tight">
//                 Contact Us
//               </h1>
//               <p className="text-lg text-gray-300">
//                 Get in touch with us for any enquiries and questions
//               </p>
//             </div>

//             {/* Contact Info Grid */}
//             <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-8">
//               {/* Mobile */}
//               <div>
//                 <h3 className="text-xl font-semibold mb-3">Mobile</h3>
//                 <div className="space-y-2">
//                   <a 
//                     href="tel:+917006363828" 
//                     className="block text-gray-300 hover:text-white transition-colors"
//                   >
//                     +91 7006363828
//                   </a>
//                   <a 
//                     href="tel:+919149516495" 
//                     className="block text-gray-300 hover:text-white transition-colors"
//                   >
//                     +91 9149516495
//                   </a>
//                 </div>
                
//                 <h3 className="text-xl font-semibold mb-3 mt-6">Address</h3>
//                 <div className="text-gray-300">
//                   <p>Chhutay rantak, sankar road, opp. Hotel antelope, Leh-Ladakh, 194101</p>
//                 </div>
//               </div>

//               {/* Mail */}
//               <div>
//                 <h3 className="text-xl font-semibold mb-3">Mail</h3>
//                 <a 
//                   href="mailto:travellerschoice27@gmail.com" 
//                   className="text-gray-300 hover:text-white transition-colors"
//                 >
//                   travellerschoice27@gmail.com
//                 </a>
//               </div>

//               {/* Social Media */}
//               <div>
//                 <h3 className="text-xl font-semibold mb-3">Social Media</h3>
//                 <div className="flex gap-3">
//                   <a 
//                     href="https://www.linkedin.com" 
//                     target="_blank" 
//                     rel="noreferrer" 
//                     className="bg-white p-2 rounded-full hover:bg-gray-100 transition-colors"
//                   >
//                     <Linkedin className="text-blue-600 w-5 h-5" />
//                   </a>
//                   <a 
//                     href="https://www.instagram.com/travellers_choice_ladakh/" 
//                     target="_blank" 
//                     rel="noreferrer" 
//                     className="bg-white p-2 rounded-full hover:bg-gray-100 transition-colors"
//                   >
//                     <Instagram className="text-pink-600 w-5 h-5" />
//                   </a>
//                   <a 
//                     href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL" 
//                     target="_blank" 
//                     rel="noreferrer" 
//                     className="bg-white p-2 rounded-full hover:bg-gray-100 transition-colors"
//                   >
//                     <Facebook className="text-blue-600 w-5 h-5" />
//                   </a>
//                   <a 
//                     href="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3" 
//                     target="_blank" 
//                     rel="noreferrer" 
//                     className="bg-white p-2 rounded-full hover:bg-gray-100 transition-colors"
//                   >
//                     <Youtube className="text-red-600 w-5 h-5" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Image Gallery Grid */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {/* Large landscape image */}
//             <div className="col-span-2 md:col-span-2">
//               <img
//                 src={p1}
//                 alt="Ladakh landscape"
//                 className="w-full h-48 md:h-64 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             {/* Valley image */}
//             <div className="col-span-1 md:col-span-1">
//               <img
//                 src={p2}
//                 alt="Mountain valley"
//                 className="w-full h-48 md:h-64 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             {/* Portrait group photo */}
//             <div className="col-span-1 md:col-span-1">
//               <img
//                 src={snow}
//                 alt="Travelers group"
//                 className="w-full h-48 md:h-64 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             {/* Second row */}
//             <div className="col-span-1">
//               <img
//                 src={lad}
//                 alt="Mountain adventure"
//                 className="w-full h-32 md:h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             <div className="col-span-1">
//               <img
//                 src={p1}
//                 alt="Snow landscape"
//                 className="w-full h-32 md:h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             <div className="col-span-1">
//               <img
//                 src={p2}
//                 alt="Ladakh scenery"
//                 className="w-full h-32 md:h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>

//             <div className="col-span-1">
//               <img
//                 src={lad}
//                 alt="Adventure group"
//                 className="w-full h-32 md:h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default React.memo(ContactUs);